import { useUncontrolledProp } from 'uncontrollable';
export function useValueControl({ value, onChange, defaultValue }) {
    return useUncontrolledProp(value, defaultValue, (newValue) => {
        const newState = typeof newValue === 'function' ? newValue(value) : newValue;
        onChange === null || onChange === void 0 ? void 0 : onChange(newState);
    });
}
